import { SVGProps } from "react";

export const CommandSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 180 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M180 27.026V4c-.692-.203-1.125-2.094-2.492-2.749a2.446 2.446 0 0 0-.287-.111C134.259.883 45.639.863.225 1.464l-.057 2.56L.09 7.826l-.073 3.723v.33l.078 2.424.141 4.015.067 1.992.175 5.11.124 3.632H.478L3.29 31.57l.535.421 175.803-.945.349-.306v-.3l.023-3.413Z"
      fill="#614018"
    />
    <path
      d="M176.467 28.15v.417s.007-.15 0-.417ZM176.451 8.495c1.181.14 2.368 2.453 3.549 2.68V8.045c-1.181-.417-2.362-2.934-3.544-3.258l-.005 3.709Z"
      fill="#614018"
    />
    <path
      d="M180 8.044V4c-.743-.213-1.204-2.356-2.779-2.86h-.765v4.145c1.181.32 2.391 2.342 3.544 2.759Z"
      fill="#7E5320"
    />
    <path
      d="M176.462 24.596V28.567l3.516 2.182V27.025c-1.131.224-2.334-2.686-3.516-2.429Z"
      fill="#614018"
    />
    <path
      d="M176.456 24.737c1.176-.257 2.368 2.512 3.544 2.289v-3.297c-1.182-.325-2.357-3.957-3.538-4.117l-.006 5.125ZM176.462 17.95c1.182-.394 2.357 2.423 3.538 2.453v-3.24c-1.181-.116-2.356-2.472-3.538-2.535v3.321ZM176.456 11.055c1.176 0 2.363 2.952 3.544 2.589v-2.468c-1.181-.228-2.368-2.54-3.549-2.681l.005 2.56Z"
      fill="#7E5320"
    />
    <path
      d="M176.462 17.95v3.393c1.182.16 2.357 2.046 3.538 2.371v-3.311c-1.153-.054-2.356-2.846-3.538-2.454ZM176.456 11.375v3.253c1.182.063 2.357 2.424 3.538 2.536v-3.52c-1.181.364-2.368-2.604-3.543-2.59l.005.32Z"
      fill="#614018"
    />
    <path
      d="M180 27.026V4c-.743-.213-1.204-2.356-2.779-2.86h-.765v27.408l3.516 2.182v-.3l.028-3.404Z"
      fill="#614018"
      style={{
        mixBlendMode: "multiply",
      }}
      opacity={0.3}
    />
    <path
      d="m176.929 28.553.355-.31-.355.31ZM.596 29.072c.343.276.535.422.535.422s-.192-.146-.535-.422ZM.09 7.826c58.982.145 117.972.368 176.968.669l.074-3.21C118.131 4.852 59.143 4.432.169 4.025l-.079 3.8Z"
      fill="#614018"
    />
    <path
      d="m177.159 5.285.09-4.145C134.287.883 45.668.863.253 1.464l-.056 2.56c58.982.33 117.969.75 176.962 1.261Z"
      fill="#7E5320"
    />
    <path
      d="m.472 25.43.124 3.642c.343.276.534.421.534.421l175.798-.94.355-.31-.068-3.506c-58.91.213-117.825.445-176.743.693Z"
      fill="#614018"
    />
    <path
      d="M.472 25.43c58.922-.265 117.836-.496 176.743-.693l-.056-3.394C118.194 21.01 59.297 20.471.298 20.306l.174 5.124ZM.231 18.327c58.858-.397 117.879-.431 176.861-.378l-.056-3.321c-58.982-.116-117.964-.221-176.946-.315l.141 4.014ZM.017 11.55c58.948 0 117.943-.177 176.985-.53l.056-2.525c-59.001-.236-117.99-.46-176.968-.67L.017 11.55Z"
      fill="#7E5320"
    />
    <path
      d="m.231 18.327.067 1.993c59 .165 117.897.703 176.862 1.038l-.068-3.394c-58.993-.068-118.003-.034-176.861.363ZM.011 11.879l.079 2.424c58.99.068 117.971.173 176.946.315l-.051-2.749v-.858c-58.982.372-117.977.548-176.985.529l.011.339ZM.472 29.062l2.813 2.516.534.422 175.804-.945.348-.306-2.778-2.38c-58.896.229-117.803.46-176.72.693Z"
      fill="#614018"
    />
    <path
      d="m.472 29.062 2.813 2.516.534.422 175.804-.945.348-.306-2.778-2.38c-58.896.229-117.803.46-176.72.693Z"
      fill="#614018"
      style={{
        mixBlendMode: "multiply",
      }}
      opacity={0.3}
    />
    <path
      d="M70.86 22.28c-.68-.067-1.627-.113-2.84-.14a181.91 181.91 0 0 0-3.98-.04c-1.173 0-2.28.013-3.32.04a61.23 61.23 0 0 0-2.6.08l-.16-2.52c1.573 0 3.113.027 4.62.08 1.507.053 2.967.133 4.38.24-.013-.347-.027-.84-.04-1.48-.013-.64-.027-1.353-.04-2.14l-.04-2.36v-2.12c-1.827 0-3.46.047-4.9.14-1.44.093-2.833.247-4.18.46l-.16-2.42c1.36-.093 2.653-.16 3.88-.2 1.227-.053 2.4-.08 3.52-.08 1.227 0 2.407.033 3.54.1 1.133.053 2.2.133 3.2.24-.04.44-.087 1.013-.14 1.72-.053.707-.113 1.487-.18 2.34-.053.84-.113 1.7-.18 2.58-.067.867-.127 1.68-.18 2.44-.053.76-.1 1.413-.14 1.96a62.85 62.85 0 0 1-.06 1.08Zm10.752 1.28a27.333 27.333 0 0 0-1.22-2.56 41.43 41.43 0 0 0-1.52-2.6 29.745 29.745 0 0 0-1.58-2.3l3.16-2.18c.373.36.793.813 1.26 1.36.467.533.933 1.1 1.4 1.7.893-.947 1.7-1.887 2.42-2.82.72-.933 1.293-1.78 1.72-2.54a26.176 26.176 0 0 0-1.74-.14c-.573-.04-1.133-.06-1.68-.06-1.493 0-3.027.113-4.6.34-1.56.227-3.327.593-5.3 1.1l-.4-2.22c2.387-.267 4.487-.46 6.3-.58 1.813-.133 3.507-.2 5.08-.2 1.147 0 2.253.033 3.32.1 1.08.053 2.187.153 3.32.3-.24.813-.593 1.7-1.06 2.66a27.896 27.896 0 0 1-1.62 2.9 31.754 31.754 0 0 1-2 2.82 31.219 31.219 0 0 1-1.7-.52 30.485 30.485 0 0 1-1.66-.6 33.933 33.933 0 0 1 1.48 2.12c.467.707.84 1.333 1.12 1.88l-4.5 2.04Zm12.13-11.6.12-3.28c.746.04 1.533.1 2.36.18.826.067 1.633.153 2.42.26.8.093 1.506.2 2.119.32l-.4 2.52a92.463 92.463 0 0 0-6.62 0Zm4 11.66a40.509 40.509 0 0 1-1.64-1.78 58.694 58.694 0 0 1-1.46-1.84c2.426-1.44 4.62-2.933 6.579-4.48 1.96-1.547 3.667-3.127 5.12-4.74l2.02 1.56c-3.026 4.867-6.566 8.627-10.62 11.28Zm12.934.34c0-6.427-.24-11.88-.72-16.36.494-.027 1.02-.053 1.58-.08a72.718 72.718 0 0 1 3.06-.08c.027.453.054.973.08 1.56.04.587.067 1.193.08 1.82a87.188 87.188 0 0 1 .08 3.38l1.26-1.42c2.054 1.093 3.694 2.227 4.92 3.4-.346.413-.68.8-1 1.16-.306.347-.653.733-1.04 1.16a13.837 13.837 0 0 0-1.26-1.1c-.493-.387-.993-.76-1.5-1.12-.506-.36-.966-.66-1.38-.9v1.7c0 .64-.006 1.313-.02 2.02v2.06a64.1 64.1 0 0 1-.02 1.74c0 .507-.006.887-.02 1.14-.386 0-.86-.007-1.42-.02a60.324 60.324 0 0 1-2.68-.06Zm8.18-12.16-2.5-.1.18-4.18 2.5.16-.18 4.12Zm2.98.3-2.38-.18c.014-.2.027-.5.04-.9.027-.4.047-.82.06-1.26.027-.453.047-.867.06-1.24.014-.387.02-.66.02-.82l2.34.16c0 .733-.013 1.46-.04 2.18a33.059 33.059 0 0 1-.1 2.06Z"
      fill="#fff"
    />
  </svg>
);
